import steps from '../../constants/GuideSteps'
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Joyride from 'react-joyride';


const Tutorials = ({ handleStartTour }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [run, setRun] = useState(false);
    const [stepIndex, setStepIndex] = useState(0);
    const handleJoyrideCallback = (data) => {
        const { status, index, action, type } = data;

        // ✅ Advance step manually
        if (type === 'step:after' || type === 'target:notFound') {
            setStepIndex(index + 1);
        }

        // ✅ Handle initial redirect to /home
        if (index === 0 && location.pathname !== '/home') {
            setRun(false); // Pause Joyride
            navigate('/home');
            setStepIndex(index);
            return; // Prevent running current step too early
        }

        if (index === 11 && location.pathname !== '/home/tools') {
            setRun(false); // Pause Joyride
            navigate('/home/tools');
            setStepIndex(index);
            return; // Prevent running current step too early
        }

        // ✅ When tour finishes
        const finishedStatuses = ['finished', 'skipped'];
        if (finishedStatuses.includes(status)) {
            handleStartTour();
            localStorage.setItem('showTutorials', 'shown');
            setRun(false);
        }
    };


    useEffect(() => {
        const stepTarget = steps[stepIndex]?.target;
        if (!stepTarget) return;

        const checkForTarget = setInterval(() => {
            const el = document.querySelector(stepTarget);
            if (el) {
                setRun(true); // Resume Joyride
                clearInterval(checkForTarget);
            }
        }, 300);

        return () => clearInterval(checkForTarget);
    }, [location, stepIndex]);
    return (
        <>
            <Joyride
                steps={steps}
                run={run}
                stepIndex={stepIndex}
                continuous
                showSkipButton
                showProgress
                callback={handleJoyrideCallback}
                scrollToFirstStep
                disableOverlayClose
                spotlightClicks
                hideBackButton
                locale={{
                    back: "Back",
                    close: "Close",
                    last: "Finish Tour",
                    next: "Next",
                    skip: "Skip",
                }}
                styles={{
                    options: {
                        zIndex: 10000,
                        arrowColor: "#2b2e4a",
                        backgroundColor: "#2b2e4a",
                        primaryColor: "#e84545",
                        textColor: "#fff",
                        overlayColor: "rgba(0, 0, 0, 0.5)",
                    },
                    tooltip: {
                        borderRadius: "12px",
                        padding: "20px",
                    },
                    buttonNext: {
                        backgroundColor: "#e84545",
                    },
                    buttonBack: {
                        marginRight: 10,
                        color: "#ccc",
                    },
                }}
            />
        </>
    )
}

export default Tutorials